'use client'

import { motion } from 'framer-motion'

export function PartnersGridPlaceholder() {
  return (
    <div className='grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-4'>
      {Array.from({ length: 8 }).map((_, index) => (
        <motion.div
          // biome-ignore lint/suspicious/noArrayIndexKey: placeholder skeleton tiles
          key={index}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.45, delay: index * 0.05, ease: 'easeOut' }}
          className='flex aspect-video items-center justify-center rounded-xl border border-borderPrimary bg-backgroundPrimary shadow-md'
        >
          <div className='h-8 w-24 animate-shimmer-pulse rounded bg-backgroundHoverOverlay' />
        </motion.div>
      ))}
    </div>
  )
}
